import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/web.dom-collections.for-each";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmTool } from "@/mixins/index";
import channelComMixins from "./mixins/channelComMixins";
import { hourlySummaryCk, hourlySummaryCkCurrency } from "@/api/dataPirate/channelData";
import * as echarts from "echarts";
export default {
  name: 'hourDetails',
  mixins: [tabulation, channelComMixins, gmTool],
  data: function data() {
    return {
      name: 'hourDetails',
      hour: '01:00',
      activeChartChannel: '',
      // 当前柱状图展示的渠道
      chartDataMap: {},
      keyVersion: '_v2'
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    getDate: function getDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.searchData.date = date;
    },

    /**
     * 整点详情 star
     */
    searchClick: function searchClick() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isverification, currentHour, res, reqFn, queryParams, queryData, rawData, channelKeys, summaryData, _channelKeys;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isverification = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                // 检查货币类型选择
                // if (this.currencyClose && !this.searchData.currency_info) {
                //   if (isverification) {
                //     this.$message.error(' 请选择货币类型');
                //   }
                //   return;
                // }
                _this.reqLoading = true;
                _this.searchData.hour = parseInt(_this.hour);
                currentHour = _this.$times.theDay('HH'); // 获取数据库数据
                // const storageKey = this.name + this.dataConvert() + this.keyVersion;
                // const dbres = await this.$DBControls.get(storageKey);
                // if(dbres && dbres.code == 500){
                //     this.searchClick(true)
                //     return
                //   }

                res = {
                  data: {}
                }; // 定义请求函数

                reqFn = _this.currencyClose ? hourlySummaryCkCurrency : hourlySummaryCk;
                _context.next = 8;
                return _this.getexchangeRate();

              case 8:
                if (_this.queryCurrency == 'VND') {
                  _this.screenList = _this.screenListVND;
                } else if (_this.queryCurrency == 'USD') {
                  _this.screenList = _this.screenListP;
                } else {
                  _this.screenList = _this.screenListP;
                }

                _this.tableDataList = _this.screenList;
                _this.screen = _this.screenList.map(function (i) {
                  return i.prop;
                });
                queryParams = _objectSpread(_objectSpread({}, _this.searchData), _this.defaultData()); // 判断是否使用数据库数据或发起新请求
                // if (dbres && currentHour !== this.searchData.hour) {
                //   res.data = dbres.content;
                // } else {

                _context.next = 14;
                return reqFn(queryParams);

              case 14:
                queryData = _context.sent;

                if (queryData.code === 200) {
                  //this.$DBControls.update(storageKey, queryData.data);
                  res.data = queryData.data;
                } // }


                _this.reqLoading = false;
                _this.tableData = [];
                _this.chartDataMap = {};
                rawData = res.data || {};
                channelKeys = Object.keys(rawData);
                summaryData = null; // 解析按渠道包裹的数据

                channelKeys.forEach(function (chKey) {
                  if (chKey === '汇总') {
                    var item = _objectSpread({}, rawData[chKey]); // 计算汇率与金额


                    item['register_recharge_device_amountexchange'] = Number(item['register_recharge_device_amount'] || 0) * _this.exchangeRate;
                    item['register_recharge_account_amountexchange'] = Number(item['register_recharge_account_amount'] || 0) * _this.exchangeRate;
                    item['account_recharge_amountexchange'] = Number(item['account_recharge_amount'] || 0) * _this.exchangeRate;

                    _this.processingListTow.forEach(function (pItem) {
                      item[pItem] = _this.isyjfmvnd() ? Number(item[pItem]) * 100 : item[pItem];
                    });

                    _this.processingList.forEach(function (pItem) {
                      item[pItem] = _this.$utils.conversion(item[pItem]).toFixed(2);
                    });

                    summaryData = _objectSpread({
                      channel_mark: item.channel_mark || _this.$t('summaryLabel'),
                      channel_name: item.channel_name || _this.$t('summaryLabel'),
                      hours: '/'
                    }, item);
                    return; // 跳过后续的 hoursObj 逻辑
                  }

                  var hoursObj = rawData[chKey] || {};
                  var hourEntries = Object.entries(hoursObj);
                  var chName = chKey;
                  var channelRows = [];
                  hourEntries.forEach(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        hourKey = _ref2[0],
                        dataItem = _ref2[1];

                    var item = _objectSpread({}, dataItem);

                    if (item.channel_name) chName = item.channel_name; // 计算汇率与金额

                    item['register_recharge_device_amountexchange'] = Number(item['register_recharge_device_amount'] || 0) * _this.exchangeRate;
                    item['register_recharge_account_amountexchange'] = Number(item['register_recharge_account_amount'] || 0) * _this.exchangeRate;
                    item['account_recharge_amountexchange'] = Number(item['account_recharge_amount'] || 0) * _this.exchangeRate;

                    _this.processingListTow.forEach(function (pItem) {
                      item[pItem] = _this.isyjfmvnd() ? Number(item[pItem]) * 100 : item[pItem];
                    });

                    _this.processingList.forEach(function (pItem) {
                      item[pItem] = _this.$utils.conversion(item[pItem]).toFixed(2);
                    });

                    var formattedHour = "".concat(Number(hourKey).toString().padStart(2, '0'), ":00");

                    var rowData = _objectSpread({
                      channel_mark: item.channel_mark || chKey,
                      channel_name: item.channel_name || chName,
                      hours: formattedHour
                    }, item); // 表格装入所有渠道的数据


                    _this.tableData.push(rowData); // 记录单渠道数据供图表筛选


                    channelRows.push(rowData);
                  });
                  _this.chartDataMap[chKey] = channelRows;
                });

                if (summaryData) {
                  _this.tableData.push(summaryData);
                } // 默认选中第一条渠道的图表


                if (_this.searchData.channel_list && _this.searchData.channel_list.length > 0) {
                  _this.activeChartChannel = _this.searchData.channel_list[0];
                } else {
                  // 2. 顶部没有选中时，默认选中后端接口/数据返回的第一条渠道
                  _channelKeys = Object.keys(rawData).filter(function (k) {
                    return k !== '汇总';
                  });

                  if (_channelKeys.length > 0) {
                    _this.activeChartChannel = _channelKeys[0];
                  } else if (_this.channelList.length > 0) {
                    _this.activeChartChannel = _this.channelList[0].channel_mark;
                  } else {
                    _this.activeChartChannel = '';
                  }
                } // 渲染柱状图


                _this.geteDetailsChart();

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleChartChannelChange: function handleChartChannelChange() {
      this.geteDetailsChart();
    },
    geteDetailsChart: function geteDetailsChart() {
      var _this2 = this;

      var chartDom = document.getElementById("echarthourDetails");

      if (this.echarthourDetails != null && this.echarthourDetails != "" && this.echarthourDetails != undefined) {
        this.echarthourDetails.dispose(); // 销毁重绘
      }

      this.echarthourDetails = echarts.init(chartDom); // 获取当前所选渠道的数据

      var activeChannelData = this.chartDataMap[this.activeChartChannel] || [];
      var series = [];
      this.screenList.forEach(function (item, index) {
        series.push({
          name: item.label,
          type: "bar",
          yAxisIndex: _this2.collectNum.findIndex(function (i) {
            return i == item.prop;
          }) > -1 ? 1 : 0,
          data: activeChannelData.map(function (i) {
            return i[item.prop];
          }),
          smooth: true,
          barMaxWidth: '50',
          symbol: "none"
        });
      });
      var option = {
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "item",
          formatter: function formatter(params) {
            return "".concat(params.seriesName, ":").concat(params.value);
          }
        },
        legend: {
          width: '100%',
          icon: 'circle',
          itemHeight: 12,
          bottom: '0%',
          itemWidth: 15,
          inactiveColor: '#666666',
          formatter: ['{a|{name}}'].join('\n'),
          textStyle: {
            fontSize: 12,
            lineHeight: 12,
            rich: {
              a: {
                width: 120,
                verticalAlign: 'middle'
              }
            },
            padding: [0, 0, -2, -4]
          },
          selected: this.Detailsselected
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "18%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          data: [this.$t('dataDetailsLabel')]
        },
        yAxis: [{
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          splitNumber: 5,
          axisLabel: {
            formatter: function formatter(value, index) {
              if (value >= 10000) {
                return (value / 10000).toFixed(2) + "万";
              } else if (value >= 1000) {
                return value;
              } else {
                return value;
              }
            }
          }
        }, {
          type: 'value',
          splitNumber: 5,
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          }
        }],
        series: series
      };
      option && this.echarthourDetails.setOption(option, true);
      var that = this;
      this.echarthourDetails.on('legendselectchanged', function (params) {
        that.Detailsselected = JSON.parse(JSON.stringify(params.selected));
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('channelId'),
        prop: 'channel_mark'
      }, {
        label: this.$t('channelName'),
        prop: 'channel_name'
      }, {
        label: this.$t('time'),
        prop: 'hours'
      }];
      this.tableDataList.forEach(function (item) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$t('hourlyDetails')
      });
    }
    /**
    * 整点详情 end
    */

  }
};